<template>
  <div class="card-text card-geo-data">
    <i class="iconoir-pin-alt card-geo-data__icon"></i>
    <span class="card-geo-data__text">{{ displayValue }}</span>
  </div>
</template>

<script>
export default {
  name: 'RowCardFieldGeoData',
  height: 16,
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  computed: {
    displayValue() {
      // Text-only, not a static map: gallery/kanban views can render many
      // cards at once, and mounting a Leaflet instance per card would be
      // needless map/tile-fetch overhead for a value that's already legible
      // as two numbers.
      if (!this.value || this.value.lat == null || this.value.lng == null) {
        return ''
      }
      return `${this.value.lat}, ${this.value.lng}`
    },
  },
}
</script>
